import { useEffect, useState } from "react";

function OttPage() {
  const [ott, setOtt] = useState([]);

  useEffect(() => {
    fetch("https://movie-backend-1wmv.onrender.com/api/articles?type=ott")
      .then(res => res.json())
      .then(setOtt)
      .catch(() => setOtt([]));
  }, []);

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-3 p-2 rounded fw-bold bg-warning text-dark">
        New OTT Releases
      </h2>

      <table className="table table-borderless">
        <thead>
          <tr>
            <th>Movie</th>
            <th>OTT Release Date</th>
            <th>Platform</th>
            <th>Genre</th>
            <th>Theatrical Release Date</th>
            <th>Language</th>
          </tr>
        </thead>

        <tbody>
          {ott.map(o => (
            <tr key={o._id}>
              <td>{o.movie}</td>
              <td>{o.releaseDate}</td>
              <td>{o.platform}</td>
              <td>{o.genre}</td>
              <td>{o.theatricalReleaseDate}</td>
              <td>{o.language}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default OttPage;
